import { render, staticRenderFns } from "./EditarReciboComponent.vue?vue&type=template&id=395c4688&"
import script from "./EditarReciboComponent.vue?vue&type=script&lang=js&"
export * from "./EditarReciboComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports